import React from 'react';
import './dropdown-menu.css';
import CanvasDropdownMenuCardOption, {
	ICanvasDropdownMenuCardOption,
} from './CanvasDropdownMenuCardOption';

export interface ICanvasDropdownMenuCardProps<Value> {
	options: ICanvasDropdownMenuCardOption<Value>[];
	value?: Value;
	header?: React.ReactNode;
}

export default function CanvasDropdownMenuCard<Value = string>(
	props: ICanvasDropdownMenuCardProps<Value>
) {
	const { options = [] } = props;

	return (
		<div className='dropdown-menu-card'>
			{props.header}
			{options.map(
				({
					label,
					iconEnd,
					iconStart,
					color = 'primary',
					tooltip,
					disabled = false,
					navigateTo,
					value,
					child,
					onClick,
					parentCanvasObject,
					style,
					classes,
					id,
					project,
				}) => {
					if (!project) {
						throw new Error('No editor instance in option')
					}
					return (
					<CanvasDropdownMenuCardOption
						key={id}
						{...{
							id,
							label,
							iconEnd,
							iconStart,
							color,
							tooltip,
							disabled,
							navigateTo,
							value,
							child,
							onClick,
							style,
							classes,
							parentCanvasObject,
							project,
						}}
					/>
				)
			}
			)}
		</div>
	);
}
